{
  "achievement-center": "अचीवमेंट सेंटर",
  "admin": "एडमिन",
  "admin-learn": "एडमिन सीखें और कमाएं",
  "admin-p2p": "एडमिन P2P",
  "admin-referrals": "एडमिन रेफरल",
  "admin-rewards": "एडमिन रिवॉर्ड्स",
  "ai-arbitrage-scanner": "एआई आर्बिट्राज स्कैनर",
  "ai-assistant": "एआई ट्रेडिंग असिस्टेंट",
  "ai-copy-trading": "एआई कॉपी ट्रेडिंग",
  "ai-grid-trading": "एआई ग्रिड ट्रेडिंग",
  "ai-launchpad": "एआई लॉन्चपैड",
  "ai-market-scanner": "एआई मार्केट स्कैनर",
  "ai-news": "एआई न्यूज़",
  "ai-portfolio": "एआई पोर्टफोलियो मैनेजर",
  "ai-profit-calculator": "एआई प्रॉफिट कैलकुलेटर",
  "ai-risk-manager": "एआई रिस्क मैनेजर",
  "ai-smart-alerts": "एआई स्मार्ट अलर्ट्स",
  "ai-trust-score": "एआई ट्रस्ट स्कोर",
  "ai-whale-alerts": "एआई व्हेल अलर्ट्स",
  "ai-whale-heatmap": "एआई व्हेल हीटमैप",
  "ai-whale-tracker": "एआई व्हेल ट्रैकर",
  "buy": "Buy",
  "certificates": "मेरे प्रमाणपत्र",
  "dashboard": "डैशबोर्ड",
  "exalt-utility-center": "एक्साल्ट यूटिलिटी सेंटर",
  "futures": "फ्यूचर्स",
  "kyc": "KYC रिक्वेस्ट",
  "kyc-submit": "KYC सबमिट करें",
  "learnearn": "लर्न एंड अर्न",
  "listings": "लिस्टिंग्स",
  "markets": "मार्केट्स",
  "notification-center": "नोटिफिकेशन सेंटर",
  "orders": "Orders",
  "p2p": "पी2पी",
  "profile": "प्रोफाइल",
  "referral": "रेफरल",
  "reputation-center": "कम्युनिटी रेपुटेशन",
  "rewards": "रिवॉर्ड्स",
  "settings": "सेटिंग्स",
  "social-trading": "सोशल ट्रेडिंग",
  "spotTrading": "स्पॉट ट्रेडिंग",
  "staking": "स्टेकिंग",
  "support": "सपोर्ट",
  "trade": "Trade",
  "transactions": "ट्रांजैक्शन्स",
  "wallets": "वॉलेट्स",
  "web3wallet": "वेब3 वॉलेट"
}